@let chart = chartSg();

@if (chart.type === ChartType.Sunburst) {
  <atn-ds-sunburst-chart [chart]="chart" />
} @else {
  <atn-ds-chart-js-chart [chart]="chart" />
}
